import type { CoachBrainApi } from "./types";
import { createHttpApi } from "./client";
import { createMockApi } from "./mock";

const mode = (import.meta.env["VITE_API_MODE"] as string | undefined) ?? (import.meta.env.DEV ? "auto" : "real");

let instance: CoachBrainApi | null = null;
let resolvedMode: "mock" | "real" = mode === "mock" ? "mock" : "real";

/** Resolve the API once. In `auto` (dev default) we probe /api/me and fall back to the mock when the API is unreachable. */
export async function getApi(): Promise<CoachBrainApi> {
  if (instance) return instance;
  if (mode === "mock") { instance = createMockApi(); resolvedMode = "mock"; return instance; }
  if (mode === "auto") {
    try {
      const res = await fetch("/api/healthz", { method: "GET" });
      if (!res.ok) throw new Error("api down");
      instance = createHttpApi(); resolvedMode = "real";
    } catch {
      instance = createMockApi(); resolvedMode = "mock";
    }
    return instance;
  }
  instance = createHttpApi(); resolvedMode = "real";
  return instance;
}
export function apiMode() { return resolvedMode; }
export type { CoachBrainApi } from "./types";
